import React from "react";
import {connect} from "react-redux";
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import ConfidentialBluePicto from "../../Picto/ConfidentialBluePicto";


class PostTag extends React.Component{
    constructor(props) {
        super(props);

    }

    render() {
        const styles = StyleSheet.create({
            postTag :{
                color:this.props.theme.colors.primary.blue1.value,
            },
            geoTag:{
                color:this.props.theme.colors.secondary.pink1.value,
                fontWeight:"bold"
            },
            tagWrapper: {
              flexDirection: "row",
              marginRight: 5,
	      alignItems: "center"
	    }
        });

        const {isGeo, tag} = this.props;

        if (isGeo) {
          return <TouchableOpacity onPress={() => {}}>
              <Text style={[styles.postTag, styles.geoTag]}>{tag.item}</Text>
          </TouchableOpacity>
        }

        return <TouchableOpacity onPress={() => this.props._navigateToEntityScreen(tag, "theme")} style={styles.tagWrapper}>
            <Text style={[styles.postTag]}>{tag.item}</Text>
	    { tag.confidential && <ConfidentialBluePicto style={{width: 12, height: 12}} isHeader={true}/> }
        </TouchableOpacity>
    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default connect(mapStateToProps)(PostTag);
